module.exports = __webpack_public_path__ + "static/media/expPurple.b47cd583.svg";